<script>
  import swal from 'sweetalert2'

  /**
   * Retorna um arquivo vazio
   * @returns Object
   */
  const emptyFile = () => ({name: '', size: '', base64: '', type: ''})

  export default {
    name: 'form-single-upload',
    props: {
      model: {
        default: function () {
          return {}
        },
        type: Object
      },
      maxFileSize: {default: 5, type: Number},
      acceptedTypes: {default: '*'},
      placeholder: {default: 'Arraste o arquivo aqui ou clique para seleciona-lo'},
      isEmpty: {default: true, type: Boolean},
      isInvalid: {default: false, type: Boolean}
    },
    data () {
      return {
        isAvailable: true,
        file: emptyFile()
      }
    },
    computed: {
      /**
       * Lista de extensões/mime types aceitos a partir da prop acceptedTypes
       * @returns Array
       */
      allowedTypes: function () {
        return String(this.acceptedTypes)
          .split(',')
          .map(item => item.trim().toLowerCase())
          .filter(item => item.length > 0)
      }
    },
    mounted: function () {
      this.file = {...emptyFile(), ...this.model}
      if (this.file.name && this.file.name.length > 0) {
        this.isAvailable = false
      } else {
        this.$emit('update:isEmpty', true)
      }
    },
    methods: {
      /**
       * Verifica se o arquivo selecionado está entre os tipos aceitos
       * Alguns navegadores não informam o mime type, então a extensão também é considerada
       * @param file
       * @returns boolean
       */
      isTypeAllowed (file) {
        if (this.allowedTypes.length === 0 || this.allowedTypes.indexOf('*') > -1) {
          return true
        }
        const name = (file.name || '').toLowerCase()
        const type = (file.type || '').toLowerCase()
        return this.allowedTypes.some(allowed => {
          if (allowed.charAt(0) === '.') {
            return name.endsWith(allowed)
          }
          if (allowed.endsWith('/*')) {
            return type.indexOf(allowed.slice(0, -1)) === 0
          }
          return type === allowed
        })
      },
      /**
       * Lê o arquivo selecionado e converte para base64
       * @param event
       */
      onChange (event) {
        const input = event.target
        const file = input.files && input.files[0]
        // Limpa o input para permitir selecionar novamente o mesmo arquivo
        input.value = ''
        if (!file) {
          return
        }
        if ((file.size / Math.pow(1000, 2)) > this.maxFileSize) {
          this.onSizeExceeded()
          return
        }
        if (!this.isTypeAllowed(file)) {
          this.onInvalidType()
          return
        }
        const reader = new window.FileReader()
        reader.onload = (e) => {
          this.file = {
            name: file.name,
            size: file.size,
            type: file.type,
            base64: e.target.result
          }
          this.isAvailable = false
          this.$emit('update:model', this.file)
          this.$emit('update:isInvalid', false)
          this.$emit('update:isEmpty', false)
        }
        reader.onerror = () => {
          this.onDelete()
          swal({
            title: 'Atenção',
            html: 'Não foi possível ler o arquivo, tente novamente.',
            type: 'error'
          })
        }
        reader.readAsDataURL(file)
      },
      onSizeExceeded () {
        swal({
          title: 'Atenção',
          html: 'O tamanho máximo do arquivo é de ' + this.maxFileSize + ' mb.',
          type: 'warning'
        })
      },
      onInvalidType () {
        swal({
          title: 'Atenção',
          html: 'Somente arquivos: ' + this.acceptedTypes + ' são permitidos.',
          type: 'error'
        })
      },
      onDelete () {
        this.file = emptyFile()
        this.isAvailable = true
        this.$emit('update:model', {})
        this.$emit('update:isInvalid', false)
        this.$emit('update:isEmpty', true)
      }
    }
  }
</script>

<template>
    <div>
        <div class="single-file-upload-box">
            <span v-if="!isAvailable">{{file.name}}</span>
            <el-button type="danger"
                       v-if="!isAvailable"
                       class="file-exists"
                       @click="onDelete">
                <i class="fa fa-times"></i>
            </el-button>
            <span class="file-icon" v-if="isAvailable">
                <i class="fa fa-upload"></i>
            </span>
            <div class="vue-base64-file-upload" v-if="isAvailable">
                <div class="vue-base64-file-upload-wrapper">
                    <input type="file"
                           class="file-input"
                           :accept="acceptedTypes"
                           @change="onChange">
                    <input type="text"
                           class="uploader"
                           :value="file.name"
                           :placeholder="placeholder"
                           disabled>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .single-file-upload-box {
        padding: 5px;
        border: 1px solid #ececec;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .file-icon {
            position: absolute;
            left: 10px;
            font-size: 20px;
            z-index: 20;
            width: 40px;
            text-align: center;
            color: #818181;
        }
        .vue-base64-file-upload {
            width: 100%;
            .vue-base64-file-upload-wrapper {
                position: relative;
                width: 100%;
            }
            .file-input {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                opacity: 0;
                overflow: hidden;
                outline: none;
                cursor: pointer;
                z-index: 30;
            }
            .uploader {
                width: 100%;
                padding-left: 50px;
                cursor: pointer;
            }
        }
    }
</style>
